// Colors based on updated brand colors
export const colors = {
  primary: '#387AAD',    // Main brand color (blue)
  secondary: '#F8A12D',  // Secondary accent color (orange)
  dark: '#2C3E50',       // Dark text and backgrounds
  light: '#F8F9FA',      // Light backgrounds
  white: '#FFFFFF',      // White
  success: '#28A745',    // Success color for buttons
  info: '#17A2B8',       // Info color
  warning: '#F8A12D',    // Warning color (using secondary orange)
  danger: '#E74C3C',     // Danger color
  textPrimary: '#2C3E50', // Primary text color
  textSecondary: '#6C757D', // Secondary text color
  bgLight: '#F5F9FC',    // Light background with slight blue tint
  cardBg: '#FFFFFF',     // Card background
  footerBg: '#2C3E50',   // Footer background (darker blue)
  footerText: '#ECF0F1', // Footer text (light)
  primaryLight: '#5D9BD4', // Lighter shade of primary
  primaryDark: '#265B85',  // Darker shade of primary
  secondaryLight: '#F9B75D', // Lighter shade of secondary
  secondaryDark: '#D98B19'  // Darker shade of secondary
};
